module.exports = __webpack_public_path__ + "img/skinbox-sale-white.fbe209b2.png";